import styled, { css } from 'styled-components';
import { Button } from 'react-bootstrap';
import theme from 'styles/theme';

export type ColorScheme = 'green' | 'purple'; // should be extended to our application styles needs.

const getColorSchemeCSS = (colorScheme: ColorScheme | undefined) => {
  if (!colorScheme) {
    return null;
  }

  const styles: Record<ColorScheme, any> = {
    green: css`
      background: ${theme.colors.bgGreen};
      border: 1px solid #1d9970;
      color: #fff;

      &:hover,
      &[disabled]:hover,
      &.btn-default[disabled]:hover,
      &:active,
      &:focus,
      &:active:focus,
      &:active:hover {
        background: #2bbd8c;
        border: 1px solid #1d9970;
        color: #fff;
      }
    `,
    purple: css`
      background: ${theme.colors.hostfullyPurple};
      border: 1px solid #51585e;
      color: #fff;

      &:hover,
      &[disabled]:hover,
      &.btn-default[disabled]:hover,
      &:active,
      &:focus,
      &:active:focus,
      &:active:hover {
        background: #7245c0 !important;
        border: 1px solid #51585e !important;
        color: #fff !important;
      }
    `,
  };

  return styles[colorScheme] || null;
};

export const StyledButton = styled(Button)<{
  $colorScheme?: ColorScheme;
  $noBorder?: boolean;
  $bigRounded?: boolean;
  $noOutlineWhenFocus?: boolean;
  $hasIcon?: boolean;
}>`
  ${({ $colorScheme }) => getColorSchemeCSS($colorScheme)}

  ${({ $noBorder }) =>
    $noBorder &&
    `
    border: none;
  `}


${({ $bigRounded }) =>
    $bigRounded &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 15px 35px;
      border-radius: 28px;
      font-size: 24px;
      font-weight: 700;
      line-height: 31px;
      letter-spacing: 0px;
      min-width: 180px;
      height: 56px;
      background: ${theme.colors.bgGreen};
      border: 1px solid #1d9970;
      color: #fff;

      &:hover,
      &:active,
      &:focus,
      &:active:focus,
      &:active:hover {
        background: #2bbd8c;
        border: 1px solid #1d9970;
        color: #fff;
      }
    `}

  ${({ $noOutlineWhenFocus }) =>
    $noOutlineWhenFocus &&
    css`
      &:focus {
        outline: none !important;
      }
    `}

  ${({ $hasIcon }) =>
    $hasIcon &&
    css`
      display: inline-flex;
      align-items: center;
      justify-content: center;
    `}

  .left-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
  }

  .right-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
  }
`;
